/* tslint:disable */
import config from './configure'
import * as qs from 'qs'
import { returnStatement } from 'babel-types'
// import { saveAs } from 'file-saver'

interface FetchOptionsInterface extends RequestInit {
  params?: object;
  raw?: boolean;
  headers?: any;
  credentials?: any;
}

export class NetworkError {
  constructor(private _data: Response, private _code: number = 500) { }

  response() {
    return this._data
  }

  code() {
    return this._code
  }

  toObject() {
    return {
      code: this._code,
      data: this._data,
      type: 'Network',
    }
  }

  toString() {
    return `${this._code}: ${this._data}`
  }
}

export const buildUrl = (url: string, params: null | object = null) => {
  const { baseUrl } = config()
  url = baseUrl + url

  const hasQueryString = /\?/.test(url)
  // If params are given, convert to query string and append to url
  if (params) {
    const queryString = qs.stringify(params, {
      encode: false,
      arrayFormat: 'brackets',
    })
    return url + (hasQueryString ? '&' : '?') + queryString
  }
  return url
}

export default (request: string, options: FetchOptionsInterface = {}, url: any = '') => {
  const { onError = () => { } } = config() // tslint:disable-line no-empty
  const { useCredentials } = config()
  // Modify options to include additional defaults
  const opts = {
    ...options,
    credentials: options.credentials || (
      useCredentials === false ? undefined : 'include'
    ),
    headers: {
      ...options.headers || {},
      'Access-Control-Allow-Origin': '*',
      'X-Requested-With': 'XMLHttpRequest',
    },
  }

  // If a data attribute was supplied, assume JSON body
  if (opts.body) {
    opts.body = JSON.stringify(opts.body)
    if (opts.method === 'GET' || !opts.method) {
      opts.method = 'POST'
    }
  }
  if (request.includes('/export_bordereaux')){
    opts.headers['Content-Type'] = 'application/octet-stream'
  }
  else{
    opts.headers['Content-Type'] = 'application/json'
  }


  if (!opts.method) {
    opts.method = 'GET'
  }

  /**
   * if url parameter is not set, use the default api server
   */
  if (url === '') {
    url = buildUrl(request, opts.params)
  }
  // if (url === 'http://staging.api.virtu.thinmartian.com/api/v1/export_bordereaux') {
  //   // fetch(url, opts).then((response) => {
  //   //   // let myBody
  //   //   // if( response.body !== null ){
  //   //   //   myBody = response.body
  //   //   // }
  //   //   // const reader = myBody.getReader()

  //   //   // const stream = new ReadableStream();
  //   //   // console.log(reader.read,stream)
  //   //   // return new Response(stream, { headers: { "Content-Type": "application/octet-stream" } })
  //   //   const contentType = 'application/octet-stream';
  //   //   response.blob().then(function(myBlob) {
  //   //     // save with myBlob
  //   //     var blob = new Blob([myBlob], {type: contentType})
  //   //     saveAs(blob, "Reporting.xlsx");
  //   //   });
  //   // })
  //   var requests = new XMLHttpRequest()
  //   requests.open('POST', url, true)
  //   requests.setRequestHeader('Content-Type', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8')
  //   requests.responseType = 'blob'

  //   requests.onload = function (e) {
  //     if (this.status === 200) {
  //       var blob = this.response;
  //       if (window.navigator.msSaveOrOpenBlob) {
  //         window.navigator.msSaveBlob(blob, __filename)
  //       }
  //       else {
  //         var downloadLink = window.document.createElement('a')
  //         var contentTypeHeader
  //         contentTypeHeader = requests.getResponseHeader("Content-Type")
  //         downloadLink.href = window.URL.createObjectURL(new Blob([blob], { type: contentTypeHeader }))
  //         downloadLink.download = __filename;
  //         document.body.appendChild(downloadLink);
  //         downloadLink.click();
  //         document.body.removeChild(downloadLink);
  //       }
  //     }
  //   };
  //   requests.send();
  // }
  return window.fetch(url, opts)
    .then((response: Response) => {
      if (!response.ok) {
        throw new NetworkError(response)
      } else {
        if (opts.raw) {
          return response.text()
        }
        // if (response.status === 202) {
        //   return true
        // }
        if (response.status === 204 || response.status === 202) {
          return true
        }

        // if (url.endsWith('/api/v1/export_bordereaux') && response.status === 200) {
        if (url.includes('/api/v1/export_bordereaux') && response.status === 200) {
          // var blob = this.response;
          // var filename = 'Reporting.xlsx'
          // if (window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveBlob(blob, filename)
          // }
          // else {
          //   var downloadLink = window.document.createElement('a')
          //   var contentTypeHeader = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          //   downloadLink.href = window.URL.createObjectURL(new Blob([blob], { type: contentTypeHeader }))
          //   downloadLink.download = filename;
          //   document.body.appendChild(downloadLink);
          //   downloadLink.click();
          //   document.body.removeChild(downloadLink);
          // }

            let body = response.body;
            if (!body) { return true } // error ?
            const reader = body.getReader();
            let uint8Array = new Uint8Array(0);

            reader.read()
                .then(function processText({ done, value }) {

                    if (done) {
                        const filename = 'Reporting.xlsx';
                        const contentTypeHeader = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                        const downloadLink = window.document.createElement('a');
                        console.debug('uint8Array:');

                        console.debug('typeof uint8Array : ', typeof uint8Array);

                        console.debug(uint8Array);
                        console.debug(uint8Array.BYTES_PER_ELEMENT);
                        console.debug(uint8Array.length);
                        console.debug(uint8Array.buffer);
                        console.debug(uint8Array.byteLength);
                        console.debug(uint8Array.byteOffset);
                        console.debug(uint8Array.length);

                        const blob = new Blob([uint8Array], { type: contentTypeHeader });
                        console.debug('blob:');

                        console.debug('typeof blob ; ', typeof blob);
                        console.debug(blob);
                        console.debug(blob.size);
                        console.debug(blob.type);
                        console.debug(blob);
                        downloadLink.href = window.URL.createObjectURL(blob);
                        downloadLink.download = filename;
                        document.body.appendChild(downloadLink);
                        console.debug(downloadLink);
                        downloadLink.click();
                        document.body.removeChild(downloadLink);
                        return;
                    }

                    console.debug('typeof uint8Array : ', typeof uint8Array);
                    console.debug('typeof value : ', typeof value);
                    uint8Array = Uint8Array.from([...uint8Array, ...value]);

                    // Read some more, and call this function again
                    return reader.read().then(processText);
                });

          return returnStatement
        }
        return response.json()
      }
    })
    .catch((error: ResponseInit) => {
      if (process.env.NODE_ENV === 'development') {
        console.error('Report:', error) // tslint:disable-line no-console
      }
      if (error instanceof NetworkError) {
        const code = error.response().status
        return error.response().json().then(resp => {
          const exception = new NetworkError(resp.error, code)
          onError(exception)
          // throw exception
          throw resp
        })
      } else {
        onError(error)
        throw error // Re-throw a native error
      }
    })
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/api/fetch.ts